import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Logo from './pages/Logo';
import Clients from './pages/Clients';
import Products from './pages/Products';
import Categories from './pages/Categories';
import EditAboutUs from './pages/EditAboutUs';
import './App.css';
import WebSettings from './pages/WebSettings';
import User from './pages/User';
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('adminToken') ? true : false
  );

  const handleLogin = (token) => {
    localStorage.setItem('adminToken', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAuthenticated(false);
  };

  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          isAuthenticated ? 
            <Navigate to="/admin/settings" replace /> : 
            <Login onLogin={handleLogin} />
        } 
      />
      <Route 
        path="/admin" 
        element={
          isAuthenticated ? 
            <AdminLayout onLogout={handleLogout} /> : 
            <Navigate to="/login" replace />
        }
      >
        {/* <Route path="dashboard" element={<Dashboard />} /> */}
        <Route path="settings" element={<Settings />} />
        <Route path="websitesettings" element={<WebSettings />} />
        <Route path="clients" element={<Clients />} />
        <Route path="products" element={<Products />} />
        <Route path="categories" element={<Categories />} />
        <Route path="edit-about-us" element={<EditAboutUs />} />
        <Route index element={<Navigate to="/admin/settings" replace />} />
        <Route path="users" element={<User />} />
      </Route>
      <Route path="/" element={<Navigate to="/admin/settings" replace />} />
    </Routes>
  );
}

export default App;
